import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import SelecaoStore from '../../../stores/SelecaoStore';

const styles = theme => ({
  entrou: {
    backgroundColor: theme.palette.grey[300],
  },
  quase: {
    backgroundColor: theme.palette.grey[200],
  },
});

class Candidatos extends React.Component {
  handleClose = () => {
    SelecaoStore.candidatos = [];
  };

  render() {
    let { classes } = this.props;
    let vagas = this.props.vagas;
    let candidatos = SelecaoStore.candidatos;
    let posicao = 1;
    let anterior = null;
    let entrou = null;
    let quase = null;
    candidatos.forEach(c => {
      if (c.projecao !== anterior) {
        c.posicao = posicao++;
        anterior = c.projecao;
        entrou = c.posicao <= vagas;
        quase = c.posicao > vagas && c.posicao <= vagas + 5;
      }
      c.entrou = entrou;
      c.quase = quase;
    });
    return (
      <Dialog
        maxWidth="md"
        fullWidth={true}
        open={candidatos.length > 0}
        onClose={this.handleClose}
      >
        <DialogTitle>Candidatos</DialogTitle>
        <DialogContent style={{ maxHeight: '500px', overflowY: 'auto' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Posição</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell>Número</TableCell>
                <TableCell>Partido</TableCell>
                <TableCell numeric>Projeção</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {candidatos.map(c => (
                <TableRow
                  key={c.id}
                  className={classNames(
                    { [classes.entrou]: c.entrou },
                    { [classes.quase]: c.quase }
                  )}
                >
                  <TableCell>{c.posicao}</TableCell>
                  <TableCell>
                    {c.candidato ? c.candidato.nome : 'Legenda'}
                  </TableCell>
                  <TableCell>
                    {c.candidato ? c.candidato.numero : c.partido.numero}
                  </TableCell>
                  <TableCell>
                    <Chip
                      key={c.id}
                      label={c.partido.sigla}
                      style={{
                        backgroundColor: c.partido.cor,
                        fontWeight: 'bold',
                        color: 'white',
                      }}
                    />
                  </TableCell>
                  <TableCell numeric>{c.projecao.formatInteger()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(observer(Candidatos));



// WEBPACK FOOTER //
// ./src/components/proporcional/distribuicao/Candidatos.js